import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Novo ")
const _hoisted_2 = {
  key: 0,
  class: "w-full grid place-content-center min-h-screen"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sim ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Não ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddOutline = _resolveComponent("AddOutline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_input = _resolveComponent("n-input")!
  const _component_n_switch = _resolveComponent("n-switch")!
  const _component_n_form = _resolveComponent("n-form")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal())),
      type: "success",
      class: "w-full"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_n_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_AddOutline)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModal) = $event)),
      "mask-closable": false,
      class: "w-full md:w-1/2",
      preset: "dialog",
      title: `Cadastrar subgrupo`,
      "positive-text": "Cadastrar",
      onPositiveClick: _ctx.createData
    }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_n_spin, { size: "large" })
            ]))
          : (_openBlock(), _createBlock(_component_n_form, {
              key: 1,
              ref: "formRef",
              model: _ctx.model,
              "label-placement": "left",
              "label-width": 160,
              class: "mt-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_form_item, {
                  label: "Grupo",
                  path: "grupo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_select, {
                      value: _ctx.model.id_grupo,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.id_grupo) = $event)),
                      options: _ctx.gruposOptions,
                      placeholder: "Grupo",
                      class: "w-full",
                      filterable: "",
                      clearable: ""
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Título",
                  path: "titulo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.titulo,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.titulo) = $event)),
                      placeholder: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Diretório",
                  path: "diretorio"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.diretorio,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.diretorio) = $event)),
                      placeholder: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Descricao",
                  path: "descricao"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_input, {
                      value: _ctx.model.descricao,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.descricao) = $event)),
                      placeholder: "",
                      type: "textarea",
                      rows: "5"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_form_item, {
                  label: "Arquivos detalhados",
                  path: "detalhamento"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_n_switch, {
                      value: _ctx.model.detalhamento,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.detalhamento) = $event))
                    }, {
                      checked: _withCtx(() => [
                        _hoisted_3
                      ]),
                      unchecked: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]))
      ]),
      _: 1
    }, 8, ["show", "onPositiveClick"])
  ], 64))
}